module.exports = __webpack_public_path__ + "static/White Logo-c4649e0b3d872cd80d8854112681058e.png";